import { useMemo } from 'react'
import * as React from 'react'
import BodyText from 'LuxKit/Typography/BodyText'
import { FormattedMessage, useIntl } from 'react-intl'

interface Props {
  offer: App.CarHireOffer
}

const boldChunks = (chunks: React.ReactNode) => <BodyText variant="small" as="span" weight="bold">{chunks}</BodyText>

function CarHireOfferTileLocation(props: Props) {
  const { offer } = props
  const intl = useIntl()

  const hasDifferentLocations = useMemo(() => offer.pickUp.id !== offer.dropOff.id, [offer])
  const pickupTypeLabelMap = useMemo(() => new Map<App.CarHirePickupType, string>([
    ['office', intl.formatMessage({
      id: '45r-mFzdNgd_-379R_eh',
      defaultMessage: 'At rental office',
      description: 'Short car hire pick-up type label for rental office location on an offer tile',
    })],
    ['shuttle', intl.formatMessage({
      id: 'Glpd4kjyroX4c3zVjAGI',
      defaultMessage: 'Free shuttle bus',
      description: 'Short car hire pick-up type label for free shuttle service on an offer tile',
    })],
    ['terminal', intl.formatMessage({
      id: 'ty6450PZ7NlrpzqGRkTd',
      defaultMessage: 'In terminal',
      description: 'Short car hire pick-up type label for in-terminal pickup on an offer tile',
    })],
  ]), [intl])

  return (
    <BodyText variant="small" colour="light-foreground-alt">
      {hasDifferentLocations && <>
        <FormattedMessage
          id="G6-2LynrI-0oK8Mar5en"
          defaultMessage="Pick up <bold>{pickUpName}</bold> ({pickUpType})"
          description="Car hire pick up location and pickup type when pick-up and drop-off locations are different"
          values={{
            pickUpName: offer.pickUp.name,
            pickUpType: pickupTypeLabelMap.get(offer.pickUp.type),
            bold: boldChunks,
          }}
        />
        <br />
        <FormattedMessage
          id="q8pyES5Byn8_VJXfMbFi"
          defaultMessage="Drop off <bold>{dropOffName}</bold> ({dropOffType})"
          description="Car hire drop off location and pickup type when pick-up and drop-off locations are different"
          values={{
            dropOffName: offer.dropOff.name,
            dropOffType: pickupTypeLabelMap.get(offer.dropOff.type),
            bold: boldChunks,
          }}
        />
      </>}
      {!hasDifferentLocations &&
        <>
          <FormattedMessage
            id="tHhfCgS79MOhHyFoo6Gm"
            defaultMessage="<bold>{locationName}</bold>"
            description="Car hire location when pick-up and drop-off are at the same rental location"
            values={{
              locationName: offer.pickUp.name,
              bold: boldChunks,
            }}
          />
          <br />
          {pickupTypeLabelMap.get(offer.pickUp.type)}
        </>}
    </BodyText>
  )
}

export default CarHireOfferTileLocation
